import { render, staticRenderFns } from "./event-quiz-results.vue?vue&type=template&id=367f7114&"
import script from "./event-quiz-results.vue?vue&type=script&lang=js&"
export * from "./event-quiz-results.vue?vue&type=script&lang=js&"
import style0 from "./event-quiz-results.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports